var envs = ['hy', 'wechat', 'h5'];

module.exports = function (sdk, api, config) {
    var register = sdk.util.register;

    var _loop = function _loop(key) {
        if (api.hasOwnProperty(key)) {
            register.setUpFunction(sdk, key, api[key], config.debug);
            sdk[key] = register.common(sdk, key, config.debug);
            envs.forEach(function (env) {
                if (api[key][env]) {
                    sdk[env][key] = register.bind(sdk, key, env);
                }
            });
        }
    };

    for (var key in api) {
        _loop(key);
    }
};


//////////////////
// WEBPACK FOOTER
// ../plugins/qunar/util/bind.js
// module id = 33
// module chunks = 1 3 4